import CheckAuth from "components/CheckAuth";
import Layout from "components/Layout";
import LayoutPublic from "components/LayoutPublic";
import CommentReportManagement from "pages/CommentReport";
import ContactUs from "pages/ContactUs";
import PostReport from "pages/PostReport";
import Privacy from "pages/Privacy";
import SignIn from "pages/SignIn";
import Terms from "pages/Terms";
import UserManagement from "pages/UserManagement";
import UserReportManagement from "pages/UserReportManagement";
import { RouteObject } from "react-router-dom";

export const routers: RouteObject[] = [
  {
    path: "/",
    element: <CheckAuth />,
    children: [
      {
        path: "",
        element: <Layout />,
        children: [
          {
            path: "user-management",
            element: <UserManagement />,
          },
          {
            path: "user-report",
            element: <UserReportManagement />,
          },
          {
            path: "comment-report",
            element: <CommentReportManagement />,
          },
          {
            path: "contact-us",
            element: <ContactUs />,
          },
          {
            path: "post-report",
            element: <PostReport />,
          },
        ],
      },
    ],
  },
  {
    path: "/",
    element: <LayoutPublic />,
    children: [
      {
        path: "sign-in",
        element: <SignIn />,
      },
      {
        path: "terms",
        element: <Terms />,
      },
      {
        path: "privacy",
        element: <Privacy />,
      },
    ],
  },
];
